/* eslint-disable react/no-unescaped-entities */
import { Button, ButtonText } from '@/components/ui/button'
import { TextField } from '@/components/ui/TextField'
import useForgotPassword from '@/services/api/auth/useForgotPassword.js'
import { Link, useSearchParams } from 'react-router-dom'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card'
import ResetSuccess from './ResetSuccess'
import { useForm, useWatch } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

export default function ForgotPasswordPage() {
  const [searchParams] = useSearchParams()

  const schema = z.object({
    email: z.string().email().min(1, 'The email field is required'),
  })
  const { register, control, handleSubmit, formState, setError } = useForm({
    defaultValues: {
      email: searchParams.get('email') ?? '',
    },
    resolver: zodResolver(schema),
  })

  const { forgotPassword, forgotPasswordStatus } = useForgotPassword({
    setError,
    clientServerFieldMapping: {},
  })

  const { errors } = formState

  const email = useWatch({
    control,
    name: 'email',
  })

  async function handleForm(val) {
    forgotPassword({ email: val?.email })
  }

  if (forgotPasswordStatus.status === 'success')
    return (
      <div className="grid min-h-screen">
        <div className="place-self-center">
          <ResetSuccess
            email={email}
            goBack={() => forgotPasswordStatus.reset()}
          />
        </div>
      </div>
    )

  return (
    <div className="grid min-h-screen">
      <Card className="place-self-center">
        <CardHeader>
          <CardTitle>Reset your password</CardTitle>
        </CardHeader>
        <CardContent>
          <p>
            Enter the email address associated with your account and we'll send
            you a link to reset your password.
          </p>
          <form className="mt-4 grid gap-3" onSubmit={handleSubmit(handleForm)}>
            <div>
              <TextField
                status={errors.email ? 'error' : null}
                statusText={errors.email?.message}
                large
              >
                <TextField.Label>Email</TextField.Label>
                <TextField.Input
                  placeholder="example@gmail.com"
                  {...register('email')}
                />
              </TextField>
            </div>

            <button className="hidden" type="submit">
              submit
            </button>
          </form>

          <div className="mt-7">
            <Button
              type="submit"
              onClick={handleSubmit(handleForm)}
              loading={forgotPasswordStatus.status === 'pending'}
              size="lg"
              className="w-full"
            >
              <ButtonText>
                {forgotPasswordStatus.status === 'pending'
                  ? 'Please wait'
                  : 'Continue'}
              </ButtonText>
            </Button>
            <p className="mt-4 text-center text-base text-txt-secondary">
              <Link
                to="/login"
                className="text-center text-txt-secondary no-underline"
              >
                Return to sign in
              </Link>
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
